import React from "react";
import { COLORS } from "@/app/common/consts/colors";

const ProfileIcon = ({
  color = "lightblack",
  className,
}: {
  color?: keyof typeof COLORS;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M15.8811 9.02821C15.562 7.67046 14.5327 6 12 6C9.46781 6 8.43844 7.66979 8.11907 9.02739C8.04129 9.33874 8 9.66455 8 10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10C16 9.99523 16 9.99046 16 9.98569C15.9988 9.65558 15.9577 9.33489 15.8811 9.02821Z"
        fill={COLORS[color]}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5144 1.12584C11.8164 0.958052 12.1836 0.958052 12.4856 1.12584L21.4856 6.12584C21.8031 6.30221 22 6.63683 22 7V17C22 17.3632 21.8031 17.6978 21.4856 17.8742L12.4856 22.8742C12.1836 23.0419 11.8164 23.0419 11.5144 22.8742L2.51436 17.8742C2.19689 17.6978 2 17.3632 2 17V7C2 6.63683 2.19689 6.30221 2.51436 6.12584L11.5144 1.12584ZM4 7.5884L4 16.4116L6.5067 17.8042C6.84587 17.1114 7.34054 16.5087 7.94522 16.0414C8.69929 15.4585 9.62457 15.0864 10.6331 15.0132C10.7543 15.0045 10.8766 15 11 15H13C13.0063 15 13.0125 15 13.0188 15C14.1351 15.0041 15.1647 15.3738 15.9946 15.9956C16.6267 16.469 17.1429 17.0886 17.4933 17.8042L20 16.4116V7.5884L12 3.14396L4 7.5884Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default ProfileIcon;
